import config from "../config/config.json";
import { OVERVIEW_ALLOWED_MODULES, isOverviewPermissionAllowed } from "./overviewAccess";

export function hasAccountAccess(resultsUserPermissions) {
    const isAdminMode = window.localStorage.getItem("isAdmin") === "true";
    const isOverviewMode = window.localStorage.getItem("isOverview") === "true";

    if (isAdminMode || isOverviewMode) {
        return true;
    }

    const isSuperUser = resultsUserPermissions?.roles?.includes("ROLE_SUPERUSER");
    if (isSuperUser) {
        return true;
    }
    
    const permissionsItems = resultsUserPermissions?.permissionsByAccount || [];
    const activeAccountUuid = window.localStorage.getItem("uuidSetCookie");
    
    if (!activeAccountUuid) {
        return false;
    }
    
    const activePermission = permissionsItems.find(
        (item) => item.accountUuid === activeAccountUuid
    );
    
    return !!activePermission;
}

export function getModuleAccess(module) {
    const isAdminMode = window.localStorage.getItem("isAdmin") === "true";
    const isOverviewMode = window.localStorage.getItem("isOverview") === "true";

    if (isOverviewMode) {
        return OVERVIEW_ALLOWED_MODULES.has(module);
    }
    if (isAdminMode) {
        let visibility = config.cards.find(e => e.routing === module)
        return visibility?.visibilityAdmin === true;
    } else {
        const additionalUserData = JSON.parse(window.localStorage.getItem("additionalUserData") || "{}");
        const isSuperUser = additionalUserData?.roles?.includes("ROLE_SUPERUSER");
        if (isSuperUser) {
            return true;
        }

        let moduleAccess = config.cards.find(e => e.routing === module)?.permissionName;
        if (!moduleAccess) {
            return true;
        }
        let permissionsItems = JSON.parse(window.localStorage.getItem("userData"))?.realmAccess || [];
        let activeCount = window.localStorage.getItem("uuidSetCookie");
        let activePermission = permissionsItems.find(item => item.uuid === activeCount);
        return activePermission?.grants?.includes(moduleAccess) || false;
    }
}

export function getActivePermissionAccess(resultsUserPermissions, moduleName) {
    const permissionsItems = resultsUserPermissions?.permissionsByAccount || [];
    const activeCount = window.localStorage.getItem("uuidSetCookie");
    const isAdminMode = window.localStorage.getItem("isAdmin") === "true";
    const isOverviewMode = window.localStorage.getItem("isOverview") === "true";

    const isSuperUser = resultsUserPermissions?.roles?.includes("ROLE_SUPERUSER");
    if (isSuperUser && !isAdminMode) {
        return true;
    }

    if (isOverviewMode) {
        return isOverviewPermissionAllowed(moduleName);
    }
    if (isAdminMode) {
        const visibility = config.cards.find(e => e.permissionName === moduleName);
        if (visibility?.visibilityAdmin === true) {
            return true;
        }
        if (moduleName.includes("/")) {
            const [permissionFather] = moduleName.split("/");
            const fatherVisibility = config.cards.find(e => e.permissionName === permissionFather);
            return fatherVisibility?.visibilityAdmin === true ?? false;
        }
    }

    const activePermission = permissionsItems.find(
        (item) => item.accountUuid === activeCount
    );

    if (moduleName.includes("/")) {
        const [permissionFather, permissionAction] = moduleName.split("/");
        const modulePermissions = activePermission?.permissions?.modules?.[permissionFather];
        return modulePermissions?.includes(permissionAction) ?? false;
    }

    const hasModuleAccess =
        activePermission?.permissions?.modules?.hasOwnProperty(moduleName) || false;

    return hasModuleAccess;
}
